import React from "react"
import { nanoid } from "nanoid"

export default function QuestionsCard(props) {
    console.log(props.allProps)
    const correct_answer = props.allProps.correct_answer
    const submitted = props.allProps.isSubmitted
    const choicesBtnArr = props.btnChoices.map((choice, i) => {

        let style;

        if (submitted && props.allProps.isCorrect && choice === correct_answer) {
            style = { backgroundColor: "#94D7A2" }
        }

        else if (submitted && !props.allProps.isCorrect && choice === correct_answer) {
            style = { backgroundColor: "#94D7A2" }
        }

        else if (submitted) {
            style = { backgroundColor: choice === props.selectedChoice ? "#F8BCBC" : "transparent" }
        }
        else style = { backgroundColor: choice === props.selectedChoice ? "#D6DBF5" : "transparent" }

        return <button
            onClick={(event) => { props.toggle(event, props.question); }}
            key={nanoid()}
            style={style}>
            {choice}
        </button>
    }

    )

    return <div className="question-card">
        <div className="question">
            <h2>{props.question}</h2>
            <div className="choices">
                {choicesBtnArr}
            </div>
        </div>
    </div>
}